import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import makeRequest from '../../../../../utils/makeRequest';
import Listingheader from '../../../../home/components/common/ListingheaderV2';
import HeaderTab from '../../../../home/components/desktop/HeaderTabV2/HeaderTab';
import s from '../PointsTableWrapper/PointsTableWrapper.scss';
import InterSectionBorder from '../../../../../components_v2/common/InterSectionBorder/InterSectionBorder';
import CricketRanking from '../CricketRanking/CricketRanking';
import LoaderSpinner from '../../../../../components_v2/common/LoaderSpinner/LoaderSpinner';

const CricketRankingWrapper = props => {
  const {
    name = '',
    path = '',
    default_url = '',
    bordertop = '',
    borderbottom = '',
    className = '',
    formats = [],
    stats = [],
    cricket_ranking = [],
    moreText = '',
    target = '',
    totalRankings = 10,
  } =
    props.sectionItem || {};

  const TEST_TEXT = 'test';
  const TEAM_TEXT = 'team';
  const [activeHeaderTab, setActiveHeaderTab] = useState(TEST_TEXT);
  const [activeGroupTab, setActiveGroupTab] = useState(TEAM_TEXT);
  const [cricketRanking, setCricketRanking] = useState(cricket_ranking);
  const [isLoading, setIsLoading] = useState(false);
  const isMounted = useRef(false);

  useEffect(
    () => {
      if (!isMounted.current) {
        isMounted.current = true;
        return;
      }
      setIsLoading(true);
      const url = default_url
        .replace(TEST_TEXT, activeHeaderTab)
        .replace(TEAM_TEXT, activeGroupTab);
      makeRequest
        .get(url, { isMobile: props.isWapView }, 'skipfeedengine')
        .then(result => {
          if (result?.data) {
            setCricketRanking(result.data);
            setIsLoading(false);
          }
        });
    },
    [activeHeaderTab, activeGroupTab],
  );

  const onHeaderTabsChange = dataObj => {
    if (
      typeof window !== 'undefined' &&
      dataObj?.clickedItem &&
      dataObj?.clickedItem?.path
    ) {
      window.location.href = dataObj?.clickedItem?.path;
      return;
    }
    if (dataObj?.clickedItem && dataObj?.clickedItem?.link && default_url) {
      setActiveHeaderTab(dataObj?.clickedItem?.link);
    }
  };

  const onGroupTabsChange = dataObj => {
    if (dataObj && dataObj?.link && default_url) {
      setActiveGroupTab(dataObj?.link);
    }
  };

  const getTabData = type => {
    const topTabData = type.map((tab, idx) => {
      let tabObj = {
        id: idx,
        name: tab.name,
        link: tab.value,
        path: tab?.path,
      };
      if (tab?.is_active && tab.is_active.toLowerCase() === 'true') {
        tabObj = {
          active: !!(tab?.is_active && tab.is_active.toLowerCase() === 'true'),
          ...tabObj,
        };
      }
      return tabObj;
    });
    return topTabData;
  };
  const headerTab = getTabData(formats);
  const groupData = getTabData(stats);

  const activeTabData = () => {
    let activeTab = 'TEAMS';
    if (Array.isArray(groupData) && groupData.length > 0) {
      const activeTabDataVal = groupData.find(gdata => gdata.active === true);
      activeTab = activeTabDataVal?.name || 'TEAMS'; // Use optional chaining and fallback to 'TEAM'
    }
    return activeTab;
  };

  return (
    <>
      {!!bordertop && <InterSectionBorder />}
      <div className={`${s.section_wrapper} ${className}`}>
        <Listingheader
          headingname={name}
          headingLink={!props.isWapView ? path : null}
        >
          {headerTab &&
            headerTab instanceof Array && (
              <HeaderTab
                subSections={headerTab}
                onChangeCallback={onHeaderTabsChange}
                // loading={this.state.loading}
                // active={sectionData && sectionData.id === 'elections' && this.tabName}
                // newga={`${sectionData.name}Section_TabChange#Click_`}
              />
            )}
        </Listingheader>

        {isLoading && <LoaderSpinner />}

        {groupData &&
          Array.isArray(groupData) &&
          groupData.length > 0 &&
          cricketRanking && (
            <CricketRanking
              groupData={groupData}
              cricketRanking={cricketRanking}
              onGroupTabsChange={onGroupTabsChange}
              currentTab={activeTabData}
              isWapView={props.isWapView}
              totalRankings={totalRankings}
              target={target}
              moreText={moreText}
              path={path}
              className={className}
            />
          )}
      </div>
      {!!borderbottom && <InterSectionBorder />}
    </>
  );
};

CricketRankingWrapper.propTypes = {
  sectionItem: PropTypes.objectOf({}),
  isWapView: PropTypes.bool,
};
CricketRankingWrapper.defaultProps = {
  sectionItem: {},
  isWapView: false,
};

export default React.memo(CricketRankingWrapper);
